module.exports = __webpack_public_path__ + "img/0105.4412f5b3.png";